import { render, staticRenderFns } from "./Edit_button.vue?vue&type=template&id=89569482&scoped=true&"
import script from "./Edit_button.vue?vue&type=script&lang=js&"
export * from "./Edit_button.vue?vue&type=script&lang=js&"
import style0 from "./Edit_button.vue?vue&type=style&index=0&id=89569482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89569482",
  null
  
)

export default component.exports